// Fetch list

export const FETCH = 'reportTrailerFuelings.FETCH'
export const FETCH_STARTED = 'reportTrailerFuelings.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportTrailerFuelings.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportTrailerFuelings.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportTrailerFuelings.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportTrailerFuelings.CLEAR'

// Export

export const EXPORT = 'reportTrailerFuelings.EXPORT'
export const EXPORT_FULFILLED = 'reportTrailerFuelings.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportTrailerFuelings.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportTrailerFuelings.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportTrailerFuelings.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportTrailerFuelings.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportTrailerFuelings.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportTrailerFuelings.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportTrailerFuelings.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportTrailerFuelings.EXPORT_DETAILS_FULFILLED'
